// extracted by mini-css-extract-plugin
export var csatScore = "_k3-5";
export var header = "_k3-1";
export var panelWrapper = "_k3-2";
export var postPreview = "_k3-3";
export var rightContent = "_k3-0";
export var wrappingText = "_k3-4";